import { global } from "../../constants";

export const data = {
  slide: {
    title: "商船水手综合物流解决方案",
    subtitle: "港口物流、技术咨询及国际海事文件管理领域的专家。",
  },

  services: {
    tag: "服务",
    title: "所有服务",
    subtitle: "值得信赖的服务",
    description:
      "我们提供全面的服务组合，旨在满足最高质量标准。客户对我们的信任直接源于我们的奉献、专业精神和持续交付卓越的能力。",
    services: [
      {
        image: global.sgallery + "1.jpg",
        title: "海事法律",
        serial: "01",
        url_service: "/services/maritime-law",
        description:
          "我们提供专业的海事法律咨询和协助，为每个案例提供全面和量身定制的解决方案。",
      },
      {
        image: global.sgallery + "tributario.webp",
        title: "税法",
        serial: "02",
        url_service: "/services/tax-law",
        description:
          "我们提供全面的税务和海关规划服务，从识别您的经济活动和商业模式开始。",
      },
      {
        image: global.sgallery + "aduanero.webp",
        title: "海关法",
        serial: "03",
        url_service: "/services/customs-law",
        description:
          "我们分析您的操作，识别适用的法规，并制定合规、降低风险和提高绩效的策略。",
      },
      {
        image: global.sgallery + "mercantil.webp",
        title: "商业法",
        serial: "04",
        url_service: "/services/commercial-law",
        description:
          "我们管理您的委内瑞拉公司的成立，进行所有法律程序，并起草商业合同。",
      },
      {
        image: global.sgallery + "seguro.webp",
        title: "保险",
        serial: "05",
        url_service: "/services/insurance",
        description:
          "我们确定您业务所需的保险和担保，包括对外贸易和运输的资产保护，以及企业个人保险。",
      },
      {
        image: global.sgallery + "administrivo.webp",
        title: "行政程序",
        serial: "06",
        url_service: "/services/administrative-processes",
        description:
          "管理活动以协调航行、港口操作和海上贸易，确保安全和法律合规。",
      },
      {
        image: global.sgallery + "sts.webp", // la imagen la proporcionas tú
        title: "STS船对船操作",
        serial: "07",
        url_service: "/services/operations-sts",
        description:
          "我们安全高效地管理STS船对船操作，实现液体货物转运，确保合规与技术监督。",
      },
    ],
  },

  clients: {
    "title": "我們的盟友",
    "logos": [
    {img: global.logo + "aras-shipping.webp", url: "https://arasshipping.us/"},
  ]},

  whychoosus: {
    title: "为什么选择我们",
    subtitle: "我们是专业的物流与货运代理",
    description:
      "您在全球供应链中的战略合作伙伴，提供专业、高效且可靠的物流与货运解决方案",
    branches: "200+",
    since: "自 2015 年以来",
    solutions: "全面的解决方案",
    specifications: [
      "超越物流，让世界运转并革新商业。",
      "通过创新、奉献和技术实现物流。准备、开始、完成。",
      "我们以安全地为客户服务而自豪。与激情同行。",
      "想象力，我们能轻易看到的只是很小的一部分。",
      "质量永不过时。安全、质量、专业。",
      "我们的每一步都展现了质量，商业在此生存。",
    ],
  },

  approach: {
    title: "公司理念",
    subtitle: "可靠的物流与运输解决方案",
    yearsOfExperience: "10",
    slogan: "多年作为综合性商业与对外贸易咨询机构的经验。",
    specifications: [
      {
        icon: global.icons + "c-pic1.png",
        count: "10",
        title: "专业员工",
      },
      {
        icon: global.icons + "pic7.png",
        count: "80",
        title: "STS船对船操作",
      },
      {
        icon: global.icons + "c-pic3.png",
        count: "50",
        title: "技术与媒体",
      },
    ],
  },

  projects: {
    title: "项目",
    subtitle: "精选项目",
    description:
      "我们最突出的项目包括为航运公司提供税务优化方案、在国际海事纠纷中提供法律辩护，以及为大型货物运输实施定制化财产保险，始终确保法律确定性和效率。",
    readMore: "阅读更多",
    projects: [
      {
        image: global.projects + "1.jpg",
        title: "存储，分发",
        subtitle: "仓库库存",
        caption: "",
      },
      {
        image: global.projects + "transfers.webp",
        title: "STS 转移流程",
        subtitle: "安全高效的运营",
        caption: "",
      },
      {
        image: global.projects + "contents.webp",
        title: "集装箱装卸",
        subtitle: "最佳装载实践",
        caption: "",
      },
      {
        image: global.projects + "4.jpg",
        title: "存储，分发",
        subtitle: "仓库库存",
        caption: "",
      },
      {
        image: global.projects + "clinsh.webp",
        title: "STS 转运检查",
        subtitle: "安全审计与合规",
        caption: "",
      },
      {
        image: global.projects + "6.jpg",
        title: "存储，分发",
        subtitle: "仓库库存",
        caption: "",
      },
    ],
  },
};
